const SET_COLEGIO_ACTIVIDAD_DATA =
  "extragestor/asignaciones/SET_COLEGIO_ACTIVIDAD_DATA";
const RESET_COLEGIO_ACTIVIDAD_DATA =
  "extragestor/asignaciones/RESET_COLEGIO_ACTIVIDAD_DATA";
const FETCH_ASIGNADAS = "extragestor/asignaciones/FETCH_ASIGNADAS";
const CHANGE_ASIGNADAS = "extragestor/asignaciones/CHANGE_ASIGNADAS";
const REMOVE_ASIGNADAS = "extragestor/asignaciones/REMOVE_ASIGNADAS";
const FETCH_ALUMNOS_ASIGNADOS =
  "extragestor/asignaciones/FETCH_ALUMNOS_ASIGNADOS";
const CHANGE_ALUMNOS_ASIGNADOS =
  "extragestor/asignaciones/CHANGE_ALUMNOS_ASIGNADOS";
const REMOVE_ALUMNOS_ASIGNADOS =
  "extragestor/asignaciones/REMOVE_ALUMNOS_ASIGNADOS";
const RESET_ALUMNOS_ASIGNADOS =
  "extragestor/asignaciones/RESET_ALUMNOS_ASIGNADOS";
const RESET_ACTIVIDADES_ASIGNADAS =
  "extragestor/asignaciones/RESET_ACTIVIDADES_ASIGNADAS";
const RESET = "extragestor/asignaciones/RESET";

/*---*/
export {
  SET_COLEGIO_ACTIVIDAD_DATA,
  RESET_COLEGIO_ACTIVIDAD_DATA,
  FETCH_ASIGNADAS,
  CHANGE_ASIGNADAS,
  REMOVE_ASIGNADAS,
  FETCH_ALUMNOS_ASIGNADOS,
  CHANGE_ALUMNOS_ASIGNADOS,
  REMOVE_ALUMNOS_ASIGNADOS,
  RESET_ALUMNOS_ASIGNADOS,
  RESET_ACTIVIDADES_ASIGNADAS,
  RESET
};



// WEBPACK FOOTER //
// ./src/ducks/asignaciones/types.js